<template lang="pug">
aside.main-menu(v-if="showMenu")

    .d-flex.flex-column.min-vh-100
      div.py-3(v-if="isOrgAdminActive")
       router-link(to='/manage/orgs' @click="resetActiveMenuItems").p-20
        img(src="@/assets/images/logos/bolt-rounded.png").size-50px
        img(src="@/assets/images/logos/logo-text@2x.png").w-170.h-30.pl-15
      div.py-3(v-else)
       router-link(to='/' @click="resetActiveMenuItems").p-20
        img(src="@/assets/images/logos/bolt-rounded.png").size-50px
        img(src="@/assets/images/logos/logo-text@2x.png").w-170.h-30.pl-15

      #nav.flex-grow-1.d-flex.flex-column.pos-r.main-menu-items(
        :class="{ 'is-collapsed': isMainMenuCollapsed }"
      )

        .px-20.mb-4
            orgs-dropdown

        el-menu(
          ref="menuRef"
          :default-active="activeMenuItem"
          :collapse="isMainMenuCollapsed"
          text-color="#303133"
          active-text-color="#303133"
          :unique-opened="true"
          @select="handleSelectMenu"
        ).flex-grow-1.d-flex.flex-column
          template(
            v-for="(item,i) in menuItems"
          )
            el-sub-menu(
              v-if="item.hasSubNav"
              :key="item.path"
              :index="item.path"
              )
              template(
                #title=''
              )
                div
                  span(v-if='item.icon && isMenuOpened(item.path)')
                    fai(type="fas" :icon="item.icon").size-24
                  span(v-else-if='item.icon')
                    fai(type="fal" :icon="item.icon").size-24
                  span.pl-15.fs-20 {{ item.label  }}
              el-menu-item-group
                el-menu-item(
                  v-for="(submenu,i) in item.subNav"
                  :index = "submenu.path"
                  :key="submenu.path"
                )
                  span.fs-18 {{ submenu.label }}
                  span(v-if='submenu.faIcon').submenu-right-icon
                    fai(type="fal" :icon="submenu.icon").size-18
            el-menu-item(
              v-else
              :key="item.path"
              :index="item.path"
              :class="isMenuActive(item.path)"
            )
              div
                span(v-if='item.icon && isMenuActive(item.path)')
                  fai(type="fas" :icon="item.icon").size-24
                span(v-else-if='item.icon')
                  fai(type="fal" :icon="item.icon").size-24
                span.pl-15.fs-20 {{ item.label  }}
          div.mt-auto
            el-menu-item(
            v-if="!isOrgAdminActive"
            index="/settings"
            :class="isMenuActive('/settings')"
            )
              fai(type="fas" icon="gear").size-24
              span.padding-left-20.fs-20 Settings
            el-menu-item(@click='handleSignOut' index="/auth")
              fai(type="fas" icon="arrow-right-from-bracket").size-24
              span.padding-left-20.fs-20 Sign out
            hr.solid.my-4.mx-4
</template>

<script lang="ts">
import { defineComponent, ref, computed, watch, nextTick } from 'vue';
import { useStore, mapGetters } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { ElMenu, ElMenuItem, ElMenuItemGroup, ElSubMenu } from 'element-plus';
import OrgsDropdown from '@/components/OrgsDropdown.vue';
import shared from '@/shared';
import orgShared from '@/views/manage-users-and-organizations/shared';
import store from "@/store";

import { dashboard as mainMenuItems,  orgAdminMenu as orgMenuItems } from '@/data/main-menu';

const selectedOrganization = computed(() => store.getters["organizations/GET_SELECTED_ORGANIZATION"]);

export default defineComponent({
  name: 'AppMainMenu',
  components: { ElMenu, ElMenuItem, ElMenuItemGroup, ElSubMenu, OrgsDropdown },

  computed: {
    ...mapGetters('shared', ['isMainMenuCollapsed']),
  },

  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const toShow = ref<boolean[]>([]);
    const { isOrgAdmin } = shared();
    const isOrgAdminActive = ref(false);
    const menuItemsCounter = ref(0);
    const menuRef = ref(null);
    const activeMenuItem = ref<string | null>(null);
      
    const isAuthenticated = computed(() => store.getters['users/isMeSignedIn']);
    const isAdminUser = computed(() => store.getters['users/isAdmin']);
    const isOrgAdminUser = computed(() => store.getters['users/isOrgAdmin']);
    console.log('isAdminUser', isAdminUser.value)
    console.log('isOrgAdminUser', isOrgAdminUser.value)
      
    const showMenu = computed(() => {
      if (route.path.startsWith('/web')) {
        return false;
      }
        
      return isAuthenticated.value && (isAdminUser.value || isOrgAdminUser.value);
    });

    const menuItems = computed(() => {
      menuItemsCounter.value;

      if (isOrgAdminUser.value) {
        isOrgAdminActive.value = true;
          
        return orgMenuItems.map((item) => {
          const i = { ...item };

          if (i.label === 'Activity') {
            i.path = selectedOrganization.value != null ? `/activity/${selectedOrganization.value.id}` : '/activity/:id'
          }

          if(i.label === 'Stickers') {
            i.path = selectedOrganization.value != null ? `/manage/orgs/${selectedOrganization.value.id}/stickers`: '/manage/orgs/ORG_ID/stickers'
          }
          return i;
        });
      }
        
      return mainMenuItems;
    });

    watch(
      () => route.params.orgId,
      (newOrgId) => {
        toShow.value = orgMenuItems.map((p) => {
          if (p.path.indexOf('ORG_ID') >= 0 && !newOrgId) {
            return false;
          }
          return true;
        });
           
        if (newOrgId && route.path.includes('/manage/orgs/') && 
              (!selectedOrganization.value || selectedOrganization.value.id !== newOrgId)) {
          console.log('Changing selected organization to match URL:', newOrgId);
            
          const { getOrganization } = orgShared();
          getOrganization(newOrgId).then(org => {
            if (org) {
              store.dispatch('organizations/SET_SELECTED_ORGANIZATION', org);
              localStorage.setItem("selectedOrganization", JSON.stringify(org));
            }
          }).catch(err => {
            console.error("Failed to fetch organization:", err);
          });
        }
      },
      { immediate: true }
    );

    watch(
      () => store.getters["organizations/GET_SELECTED_ORGANIZATION"],
      () => {
        menuItemsCounter.value++;
      }
    );

    const isMenuActive = (vRoute: string): string => {
      if (route.path === vRoute) return 'is-active';
      return '';
    };
    const isMenuOpened = (vRoute: string): boolean => {
      if (route.path.indexOf(vRoute + "/") >= 0) return true;
      return false;
    };

    const handleSelectMenu = (key: string): void => {
      if (route.path === key) return;
      router.push({ path: key });
    };

    const goBack = () => {
      router.go(-1);
    };
    const handleSignOut = () => {
      localStorage.clear();
      store.dispatch('organizations/SET_SELECTED_ORGANIZATION', null);
      store.dispatch('users/resetMe');
      router.push('/auth');
    };

    const resetActiveMenuItems = () => {
      activeMenuItem.value = null;
      nextTick(() => {
        try {
          const openedSubMenuTitles = document.querySelectorAll('.el-sub-menu.is-opened .el-sub-menu__title');
          openedSubMenuTitles.forEach(title => {
            // Simulate click to toggle submenu closed
            const clickEvent = new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: true,
            });
            title.dispatchEvent(clickEvent);
          });
          const activeMenuItems = document.querySelectorAll('.el-menu-item.is-active');
          activeMenuItems.forEach(item => {
            item.classList.remove('is-active');
          });
        } catch (error) {
          console.log('Menu reset error:', error);
        }
      });
    };

    return {
      activeMenuItem: ref(null),
      isOrgAdmin,
      toShow,
      menuItems,
      showMenu,
      isOrgAdminActive,
      isAuthenticated,
      isAdminUser,
      isOrgAdminUser,
      isMenuActive,
      isMenuOpened,
      handleSelectMenu,
      handleSignOut,
      goBack,
      resetActiveMenuItems,
      menuRef,
    };
  },
});
</script>

<style lang="scss" scoped>
.main-menu {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 280px;
  background: #ffffff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  transition: all 0.3s ease;

  &.is-collapsed {
    width: 64px;
  }
}

.min-vh-100 {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.p-20 {
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.size-50px {
  width: 50px;
  height: 50px;
}

.w-170 {
  width: 170px;
}

.h-30 {
  height: 30px;
}

.main-menu-items {
  flex: 1;
  overflow-y: auto;
  padding: 20px 0;
}

.px-20 {
  padding-left: 20px;
  padding-right: 20px;
}

.mb-4 {
  margin-bottom: 1rem;
}

.el-menu {
  border-right: none;
  background: transparent;
  padding: 0 12px;

  :deep(.el-menu-item) {
    height: 48px;
    line-height: 48px;
    border-radius: 8px;
    margin: 4px 0;
    transition: all 0.2s ease;

    &:hover {
      background: #f5f5f5;
    }

    &.is-active {
      background: #f0f7ff;
      color: #409eff;
      font-weight: 500;
    }
  }

  :deep(.el-sub-menu) {
    .el-sub-menu__title {
      height: 48px;
      line-height: 48px;
      border-radius: 8px;
      margin: 4px 0;
      transition: all 0.2s ease;

      &:hover {
        background: #f5f5f5;
      }
    }
  }
}

.size-24 {
  width: 24px;
  height: 24px;
}

.pl-15 {
  padding-left: 15px;
}

.fs-20 {
  font-size: 20px;
  font-weight: 500;
}

.fs-18 {
  font-size: 18px;
}

.submenu-right-icon {
  margin-left: auto;
}

.mt-auto {
  margin-top: auto;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.padding-left-20 {
  padding-left: 20px;
}

.solid {
  border: none;
  border-top: 1px solid #f0f0f0;
  margin: 1rem 0;
}

.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;

  &:hover {
    background: #a8a8a8;
  }
}
</style>
